import React from 'react'
import { Button } from 'primereact/button'

interface PageHeaderButton {
  label: string
  icon: string
  onClick?: () => void
  outlined?: boolean
  severity?: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help'
}

interface PageHeaderProps {
  title: string
  description: string
  backgroundImage?: string
  buttons?: PageHeaderButton[]
  height?: string
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  backgroundImage,
  buttons,
  height = '500px'
}) => {
  return (
    <div className="w-full" style={{ height, position: 'relative', overflow: 'hidden' }}>
      {backgroundImage && (
        <img 
          src={backgroundImage} 
          alt={`${title} Background`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            filter: 'blur(5px)',
            transform: 'scale(1.1)'
          }}
        />
      )}
      
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: backgroundImage ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.7)',
        zIndex: 1
      }} />
      
      <div style={{
        position: 'relative',
        zIndex: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '1rem'
      }}>
        <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1rem' }}>
          {title}
        </h1>
        <p style={{ color: 'white', fontSize: '1.5rem', marginBottom: '2rem', maxWidth: '800px' }}>
          {description}
        </p>
        {buttons && buttons.length > 0 && (
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            {buttons.map((button, index) => (
              <Button 
                key={index}
                label={button.label}
                icon={button.icon}
                iconPos="right"
                severity={button.severity}
                outlined={button.outlined}
                onClick={button.onClick}
                style={{ 
                  fontSize: '1.1rem', 
                  padding: '0.75rem 2rem',
                  color: button.outlined ? 'white' : undefined,
                  borderColor: button.outlined ? 'white' : undefined,
                  borderWidth: button.outlined ? '2px' : undefined,
                  gap: '0.5rem'
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}